import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { darken } from 'polished';

import breakpoints from '../../styles/breakpoints';

const Content = styled.div`
  color: ${p => p.theme.colors.lightFont};
  font-size: 1.25rem;
  font-weight: 300;
  line-height: 2;
  margin: 0 auto 60px auto;
  max-width: ${p => p.theme.globalWidthXSmall};

  h2 {
    margin: 45px 0 23px 0;

    ${breakpoints.medium`
      margin: 56px 0 23px 0;
    `};

    ${breakpoints.large`
      margin: 90px 0 23px 0;
    `};
  }

  a {
    border-bottom: 1px solid ${p => p.theme.colors.primary};
    color: ${p => p.theme.colors.lightFont};
    padding-bottom: 2px;
    text-decoration: none;
    transition: border-color 0.5s, padding 0.2s;

    &:hover {
      border-color: ${p => darken(0.2, p.theme.colors.primary)};
      padding-bottom: 0;
    }
  }

  .wp-caption a {
    border: none;
    padding: 0;
  }
`;

export default function RawHTML({ html }) {
  if (!html) return null;

  return (
    <Content>
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </Content>
  );
}

RawHTML.propTypes = {
  html: PropTypes.string
};
